import React, { useContext } from 'react';
import ShopRegion from '../components/shop-region';
import { SpecialStatusContext } from './shop-items-root';
/**
 * リージョン分けしたショップ一覧を作成する
 */
const createShopRegions = (regionID, shopItems, shopItemsOrder, specialStatus) => {
    const result = [];
    for (const orderItem of shopItemsOrder) {
        if (!shopItems.hasOwnProperty(orderItem.region_name)) {
            continue;
        }
        let className = '';
        // キャンペーン表示状態なら
        if (specialStatus) {
            className = 'hidden';
        }
        // 選択中のregionIDが0（全表示）ではなく自分のregionIDと一致しない場合
        else if (regionID !== orderItem.region_id && regionID !== '0') {
            className = 'hidden';
        }
        result.push(React.createElement("div", { key: orderItem.region_name, className: className },
            React.createElement(ShopRegion, { regionName: orderItem.region_name, shopItemList: shopItems[orderItem.region_name] })));
    }
    return result;
};
/**
 * キャンペーン対象店舗を生成する
 */
const createShopCampaign = (shopItems, shopItemsOrder, specialStatus) => {
    const lastOfOrder = shopItemsOrder[shopItemsOrder.length - 1];
    const campaignShopList = [];
    // オーダー順ですべての店舗要素にアクセスする
    for (const orderItem of shopItemsOrder) {
        if (!shopItems.hasOwnProperty(orderItem.region_name)) {
            continue;
        }
        const shopItemList = shopItems[orderItem.region_name];
        // キャンペーン対象店舗のみを抽出する
        for (const shopItem of shopItemList) {
            if (shopItem.special) {
                campaignShopList.push(shopItem);
            }
        }
    }
    let className = '';
    // キャンペーン選択状態でなければ非表示
    if (!specialStatus) {
        className = 'hidden';
    }
    return (React.createElement("div", { className: className },
        React.createElement(ShopRegion, { regionName: lastOfOrder.region_name, shopItemList: campaignShopList })));
};
const ShopRegionAll = ({ regionID, shopItems, shopItemsOrder }) => {
    const specialStatus = useContext(SpecialStatusContext);
    return (React.createElement("div", { className: "mt-10", id: "js-shop" },
        createShopRegions(regionID, shopItems, shopItemsOrder, specialStatus),
        createShopCampaign(shopItems, shopItemsOrder, specialStatus)));
};
export default ShopRegionAll;
